import { Form } from 'antd';

interface TaskFormProps {
	onAddTask: (values: any) => void;
}

const { useForm } = Form;

export function useTaskForm({ onAddTask }: Readonly<TaskFormProps>) {
	const [form] = useForm();

	async function handleOnClick(): Promise<void> {
		const values = await form.validateFields();
		onAddTask(values);

		form.resetFields();
	}

	return {
		form,
		handleOnClick
	};
}
